var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerMenu5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 17.6471H25.5C26.325 17.6471 27 16.9853 27 16.1765C27 15.3676 26.325 14.7059 25.5 14.7059H1.5C0.675 14.7059 0 15.3676 0 16.1765C0 16.9853 0.675 17.6471 1.5 17.6471ZM1.5 10.2941H25.5C26.325 10.2941 27 9.63235 27 8.82353C27 8.01471 26.325 7.35294 25.5 7.35294H1.5C0.675 7.35294 0 8.01471 0 8.82353C0 9.63235 0.675 10.2941 1.5 10.2941ZM0 1.47059C0 2.27941 0.675 2.94118 1.5 2.94118H25.5C26.325 2.94118 27 2.27941 27 1.47059C27 0.661765 26.325 0 25.5 0H1.5C0.675 0 0 0.661765 0 1.47059Z",
    fill: "#009BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 25H1.5C0.675 25 0 24.3382 0 23.5294C0 22.7206 0.675 22.0588 1.5 22.0588H25.5C26.325 22.0588 27 22.7206 27 23.5294C27 24.3382 26.325 25 25.5 25Z",
    fill: "#009BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu5);
export default __webpack_public_path__ + "static/media/HamburgerMenu5.79c0ab8a9473fc51eb73e590092241d9.svg";
export { ForwardRef as ReactComponent };